































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";

@Component({
  name: "AgroResponsiveTable",
  components: {
    AgroIcons,
  },
  filters: {
    cropWords(value: string, maxLength: number) {
      if (!value) {
        return "";
      }

      if (value.length <= maxLength) {
        return value;
      }

      return `${value.toString().split("").slice(0, maxLength).join("")}...`;
    },
  },
})
export default class AgroResponsiveTable extends Vue {
  @Prop({ type: String, required: true  }) private prefix!: string;

  @Prop({ type: Array, required: true }) private rows!: any[];

  @Prop({ type: Object, required: true }) private columnsLabel!: {};

  @Prop({ type: Array, default: () => [] })
  private tableColumns!: any[];

  @Prop({ default: false, type: Boolean }) 
  private showPagination!: boolean;

  @Prop({ type: Function, default: () => false })
  private highligthed!: (arg0: any) => boolean;

  @Prop({ default: false, type: Boolean }) 
  private backendSort!: boolean;

  @Prop({ type: Boolean, default: false }) private isSmall!: boolean;

  private currentSortKey: string | null = null;
  private currentSortDir: 'asc' | 'desc' = 'desc';

  private get sortedRows() {
    const modifier = this.currentSortDir === 'asc' ? 1 : -1;
   
    if (this.currentSortKey === null || this.backendSort) {
      return this.rows.flat()
    } else if (this.currentSortKey === 'cropStages') {
      return this.rows.flat().sort((a, b) => this.cropStageSort(modifier, a, b));
    } else {
      return this.rows.flat().sort((a, b) => this.defaultSort(modifier, a, b));
    }
  }

  private defaultSort(modifier: any, aCol: any, bCol: any)  {
    let a = aCol[this.currentSortKey as string];
    let b = bCol[this.currentSortKey as string];
    a = a === 'false' || a === undefined ? 0 : a == 'true' ? 1 : a;
    b = b === 'false' || b === undefined ? 0 : b == 'true' ? 1 : b;
    return a === b ? 0 : (a > b) ? modifier : -modifier;
  }

  private cropStageSort(modifier: any, aCol: any, bCol: any)  {
    let a = aCol[this.currentSortKey as string];
    let b = bCol[this.currentSortKey as string];
    a = a.filter((it: any) => it.date != undefined).length
    b = b.filter((it: any) => it.date != undefined).length
    return a === b ? 0 : (a > b) ? modifier : -modifier;
  }

  private sortByColumn(sortKey: string) {
    if (sortKey === this.currentSortKey) {
      this.currentSortDir = (this.currentSortDir === 'asc') ? 'desc' : 'asc';
    }
    this.currentSortKey = sortKey;
    if (this.backendSort) {
      this.$emit("sorted", {"key": this.currentSortKey, "dir": this.currentSortDir.toUpperCase()});
    }
  }

}
